module.exports = __webpack_public_path__ + "img/clipedBigger-detail-orange.63ce76a9.svg";